import { render, staticRenderFns } from "./CultivarList.vue?vue&type=template&id=6c898c18&scoped=true"
import script from "./CultivarList.vue?vue&type=script&lang=js"
export * from "./CultivarList.vue?vue&type=script&lang=js"
import style0 from "./CultivarList.vue?vue&type=style&index=0&id=6c898c18&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c898c18",
  null
  
)

export default component.exports